import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    channels: [],
    is_signed_in: false,
    users: [],
    users_object: {},
}

export default { mutations, actions, state }